export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/70 pt-12 md:pt-16 pb-6 px-4 md:px-6">
      <div className="max-w-[1100px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-fill text-background-50"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料吃瓜爆料</span>
            </div>
            <p className="text-xs leading-relaxed">
              全网最全的明星八卦和网络爆料聚合平台。搜你想搜，看你所看——吃瓜群众的终极武器。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速导航</h4>
            <div className="space-y-2">
              <a href="#updates" className="block text-xs hover:text-primary-400 transition-colors">最新快讯</a>
              <a href="#topics" className="block text-xs hover:text-primary-400 transition-colors">话题热榜</a>
              <a href="#ranking" className="block text-xs hover:text-primary-400 transition-colors">实时热搜榜</a>
              <a href="#cards" className="block text-xs hover:text-primary-400 transition-colors">深度实锤</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">热门专题</h4>
            <div className="space-y-2">
              <a href="#index" className="block text-xs hover:text-primary-400 transition-colors">明星恋情实锤合集</a>
              <a href="#index" className="block text-xs hover:text-primary-400 transition-colors">网红翻车大赏</a>
              <a href="#index" className="block text-xs hover:text-primary-400 transition-colors">娱乐圈税务风波</a>
              <a href="#index" className="block text-xs hover:text-primary-400 transition-colors">直播带货内幕</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-xs leading-relaxed">敬请期待合作伙伴入驻。如有合作意向，欢迎通过投稿入口联系我们。</p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs">&copy; 2026 黑料吃瓜爆料网. 本站内容仅供娱乐参考。</p>
          <div className="flex items-center gap-4 text-xs">
            <span>搜索黑料</span>
            <span>吃瓜查询</span>
            <span>查找爆料</span>
            <span>明星八卦搜索</span>
          </div>
        </div>
      </div>
    </footer>
  );
}